"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncompleteCartCms = void 0;
var IncompleteCartCms = /** @class */ (function () {
    function IncompleteCartCms() {
        this.wirelessPlanIsMissingLinkLabel = 'Add a wireless plan';
        this.wirelessDeviceIsMissingLinkLabel = 'Add a device';
        this.wirelessCellphoneIsMissingLinkLabel = 'Add a cell phone';
        this.configIsIncompleteLinkLabel = 'Finish configuring your service';
        this.apiErrTxt = "Looks like you missed a few steps. Let's go back and add the items that'll complete your cart.";
        this.cellphoneErrTxt = "To complete your cart, your selected plan requires at least one smartphone.";
        this.errMessageHeading = 'Something\'s missing';
        this.mixAndMatchErrorLabel = 'Look for the alerts and follow the steps to complete your order.';
        this.mixAndMatchNoDeviceError = 'To complete your cart, you need to add at least one eligible smartphone.';
        this.mixAndMatchGoBack = 'Go Back';
        this.lineAdditionLabel = 'You\'ve succesfully added [{0}] lines to your order. To continue add a device for each line';
    }
    return IncompleteCartCms;
}());
exports.IncompleteCartCms = IncompleteCartCms;
//# sourceMappingURL=IncompleteCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/IncompleteCart.cms.js
// module id = 1429
// module chunks = 8